import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { useMemo } from 'react';
import { ApplicationDataFieldContext } from './types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { MarketCountryCode } from '@axo/shared/types';
import { Product } from '@axo/shared/data-access/types/loan_quote';
import { useApplicationDataStore } from '../../../store/applicationDataStore';

export function useApplicationDataFieldContext(
  applicationID: string,
): ApplicationDataFieldContext {
  const { data: applicationData } = useLoanApplication(applicationID);
  const { isEditing } = useApplicationDataStore(applicationID);

  return useMemo(
    () => ({
      broker: applicationData?.Meta?.Broker ?? Broker.Axo,
      marketCountry:
        (applicationData?.MarketCountry as MarketCountryCode) ??
        MarketCountryCode.Norway,
      productType: applicationData?.Product ?? Product.UnsecuredLoan,
      isEditing,
    }),
    [
      applicationData?.MarketCountry,
      applicationData?.Meta?.Broker,
      applicationData?.Product,
      isEditing,
    ],
  );
}
